export default __webpack_public_path__ + "assets/e52a5c00d3efcbab091a313bf860ca10.svg";